const VALID_VERIFICATION_STATUSES = new Set(['verified', 'autocomplete', 'unverified']);
const CONDITIONALLY_MAJOR_FIELDS = new Set(['address1', 'city', 'region', 'postalCode']);

export const getIncomingVerificationStatus = (address = null) => {
  const status = address?.verification?.status;
  return VALID_VERIFICATION_STATUSES.has(status) ? status : 'unverified';
};

export const buildAddressVerification = (status = 'unverified', source = null, options = {}) => {
  const {
    verifiedAt = (status === 'unverified' ? null : new Date().toISOString()),
    manuallyEdited = false,
    editedFields = []
  } = options;

  const verification = {
    status,
    ...(source ? { source } : {}),
    ...(verifiedAt ? { verifiedAt } : {}),
    ...(manuallyEdited ? { manuallyEdited: true } : {}),
    ...(editedFields.length ? { editedFields: [...new Set(editedFields)] } : {})
  };

  return verification;
};

export const withAddressVerification = (address = {}, status = 'unverified', source = null, options = {}) => ({
  ...address,
  verification: buildAddressVerification(status, source, options)
});

export const isMajorManualEditField = (field, lookupField = 'address1', requiredFields = []) => (
  field === lookupField ||
  (CONDITIONALLY_MAJOR_FIELDS.has(field) && requiredFields.includes(field))
);

export const getManualEditVerificationStatus = (
  currentStatus = 'unverified',
  field,
  lookupField = 'address1',
  requiredFields = []
) => {
  if (currentStatus === 'unverified') {
    return 'unverified';
  }

  return isMajorManualEditField(field, lookupField, requiredFields) ?
    'unverified' :
    currentStatus;
};

export const withManualAddressVerificationEdit = (
  address = {},
  field,
  nextStatus = 'unverified'
) => {
  const existingVerification = address?.verification || {};
  const editedFields = [...(existingVerification.editedFields || []), field];

  return {
    ...address,
    verification: buildAddressVerification(
      nextStatus,
      existingVerification.source || null,
      {
        verifiedAt: existingVerification.verifiedAt || null,
        manuallyEdited: true,
        editedFields
      }
    )
  };
};
